export const NAMESPACE = '@pegasus/abtesting';
export const ASSIGNMENTS_CLIENT_ID = 'clientid';
export const ASSIGNMENTS_CUSTOMER_HASH = 'customerHash';
export const OCTOPUS_MODE_ACTIVE = 'TEST';
export const OCTOPUS_MODE_FORCED = 'FORCED';
export const OCTOPUS_MODE_QA = 'QA';
export const OCTOPUS_MODE_NOT_IN_THE_TEST = 'NOT_IN_THE_TEST';
export const OCTOPUS_MODE_CLIENT = 'CLIENT';
//# sourceMappingURL=constants.js.map